import React, { useState, useCallback } from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import SettingsLayout from '../../../components/Admin/Settings/SettingsLayout';
import ReceiptConfigurations from '../../../components/Admin/Settings/ReceiptConfigurations';

/**
 * Receipt Configuration Settings Page
 *
 * Customize bill and KOT receipt templates with branding.
 * Action buttons are rendered in the sticky header.
 */
export default function ReceiptConfigPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header
  const headerActions = componentActions ? (
    <>
      <button
        onClick={componentActions.onAdd}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
      >
        <Plus size={16} />
        New Template
      </button>
      <button
        onClick={componentActions.onRefresh}
        className="p-1.5 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 border border-slate-200"
      >
        <RefreshCw size={16} />
      </button>
    </>
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <ReceiptConfigurations renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
